import { render } from "./MealSetModal.vue?vue&type=template&id=cf46591c"
import script from "./MealSetModal.vue?vue&type=script&lang=js"
export * from "./MealSetModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__